// extracted by mini-css-extract-plugin
export default {"footer":"w_K9P64lvOmHBqpltaWQ","footer__holder":"XLn7AHZrLKAro0Puav7e"};